module.exports = __webpack_public_path__ + "static/media/vacuum.04077b48.svg";